import { useQuery } from "react-query";
import Select from "react-select";

import { getCompanies } from "../../../../../MyApi/hr/companies";
import { getRules } from "../../../../../MyApi/sb/rules";

import icons from "../../../../../Data/icons";
import LoadingSpinner from "../../../../UI/spinner";
import classes from "./addCompanyFields.module.css";
const EditCompanyRules = ({
  setCompanyId,
  setDuration,
  setRuleId,
  setValue,
  ruleId,
  duration,
  value,
  companyId,
  active,
  setActive,
  process_type,
  setProcessType,
}) => {
  const companyQuery = useQuery("getCompanies", getCompanies);
  const rulesQuery = useQuery("getRules", getRules);

  const DurationIcon = icons.duration;
  const ValueIcon = icons.value;
  
  const companies = companyQuery.data?.data || [];
  const rules = rulesQuery.data?.data || [];

  const handleCompanyIdChange = (selectedCompany) => {
    const companyId = selectedCompany ? selectedCompany.id : 0;
    setCompanyId(companyId);
  };
  const handleRulesIdChange = (selectedRules) => {
    const rulesId = selectedRules ? selectedRules.id : 0;
    setRuleId(rulesId);
  };
  const handleDurationChange = (e) => {
    setDuration(e.target.value);
  };
  const handleValueChange = (e) => {
    setValue(e.target.value);
  };
  const handleActiveChange = (e) => {
    const isChecked = e.target.checked;
    setActive(isChecked ? 1 : 0);
  };

  const handleProcessTypeChange = (e) => {
    setProcessType(e.target.value);
  };
  const defaultRule = rules.find((option) => option.id === ruleId);
  const defaultCompany = companies.find((option) => option.id === companyId);

  if (rulesQuery.isLoading || companyQuery.isLoading) {
    return <LoadingSpinner />;
  }
  return (
    <div className={classes.formCard}>
      <div className={classes.formGrid}>
        <div className={classes.formCol}>
          <label htmlFor="">ادخل الشركة </label>
          {!companyQuery.data ? (
            <div>no data avalible</div>
          ) : (
            <Select
              type="text"
              placeholder="ادخل  الشركة"
              value={defaultCompany}
              getOptionLabel={(e) => e.name}
              getOptionValue={(e) => e.id}
              options={companies}
              onChange={handleCompanyIdChange}
            />
          )}
        </div>
        <div className={classes.formCol}>
          <label htmlFor="">ادخل القاعده </label>
          {!rulesQuery.data ? (
            <div>no data avalible</div>
          ) : (
            <Select
              type="text"
              placeholder="ادخل  القاعده"
              value={defaultRule}
              getOptionLabel={(e) => e.name}
              getOptionValue={(e) => e.id}
              options={rules}
              onChange={handleRulesIdChange}
            />
          )}
        </div>
        <div className={classes.formCol}>
          <label htmlFor=""> المده </label>
          <div className={classes.iconInput}>
            <DurationIcon />
          </div>
          <input
            type="text"
            placeholder="المده"
            value={duration}
            onChange={handleDurationChange}
            className={classes.inputCustom}
          />
        </div>
        <div className={classes.formCol}>
          <label htmlFor=""> القيمه </label>
          <div className={classes.iconInput}>
            <ValueIcon />
          </div>
          <input
            type="number"
            placeholder="القيمة"
            value={value}
            onChange={handleValueChange}
            className={classes.inputCustom}
          />
        </div>
        <div className={classes.formCol}>
          <label htmlFor="">نوع العملية</label>
          <select className="form-select" onChange={handleProcessTypeChange}>
            <option>اختار نوع العملية</option>
            <option value="amount" selected={process_type === "amount"}>
              amount
            </option>
            <option value="days" selected={process_type === "days"}>
              days
            </option>
          </select>
        </div>
        <div className={classes.formCol}>
          <label
            htmlFor="active"
            className={active ? `${classes.active}` : `${classes.disActive}`}>
            {" "}
            {active === 1 ? " نشط" : "غير نشط"}{" "}
          </label>

          <label class="switch">
            <input
              type="checkbox"
              onChange={handleActiveChange}
              checked={active}
            />
            <span class="slider round"></span>
          </label>
        </div>
      </div>
    </div>
  );
};

export default EditCompanyRules;
